'use strict';

var React = require('react');
var DialogContent = require('./DialogContent.js');
var makeStyles = require('../../Styles/makeStyles.js');
var FailureAlert = require('../../../IconsAndImages/Images/FailureAlert.js');
var SuccessAlert = require('../../../IconsAndImages/Images/SuccessAlert.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"]({
  alertImage: {
    marginBottom: 24,
    maxWidth: 250,
    maxHeight: 250
  },
  dialogContent: {
    textAlign: 'center',
    marginBottom: 16
  }
});

var AlertDialogContent = function AlertDialogContent(_ref) {
  var variant = _ref.variant,
      children = _ref.children;

  var _useStyles = useStyles();
      _useStyles.alertImage;
      var dialogContent = _useStyles.dialogContent;

  return React__default["default"].createElement(DialogContent, {
    className: dialogContent
  }, variant === "failure" && React__default["default"].createElement(FailureAlert, null), variant === "success" && React__default["default"].createElement(SuccessAlert, null), children);
};

module.exports = AlertDialogContent;
